/* Extras de Framesi: sugerencias del buscador y barra de compra fija en celular. */
(function () {
  'use strict';
  if (window.__fxExtras) return;
  window.__fxExtras = true;

  var RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function pesos(valor) {
    var v = parseFloat(valor);
    if (isNaN(v)) return '';
    var cent = Math.round(v * 100) % 100 !== 0;
    return '$ ' + v.toLocaleString('es-MX', {
      minimumFractionDigits: cent ? 2 : 0,
      maximumFractionDigits: cent ? 2 : 0
    });
  }

  function conAncho(url, ancho) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + ancho;
  }

  /* ---------- Sugerencias del buscador ---------- */
  function iniciarBusqueda() {
    var input = document.getElementById('framesi-global-search');
    if (!input || !input.form) return;
    var form = input.form;
    var nota = form.parentNode.querySelector('.search-sheet-note');
    var caja = document.createElement('div');
    caja.className = 'fx-pred';
    caja.id = 'fx-pred';
    caja.hidden = true;
    caja.setAttribute('aria-live', 'polite');
    form.insertAdjacentElement('afterend', caja);
    input.setAttribute('aria-controls', 'fx-pred');
    input.setAttribute('aria-autocomplete', 'list');

    var espera = null;
    var control = null;

    function limpiar() {
      caja.hidden = true;
      caja.innerHTML = '';
      if (nota) nota.hidden = false;
    }

    function pintar(q, res) {
      var productos = res.products || [];
      var colecciones = res.collections || [];
      var html = '';
      if (!productos.length && !colecciones.length) {
        html = '<p class="fx-pred__vacio">No encontramos nada para «' + esc(q) +
          '». Prueba con una línea (Morphosis, FOR-ME, Barber Gen) o con lo que necesita tu cabello (frizz, caída, rizos).</p>';
      } else {
        if (productos.length) {
          html += '<p class="fx-pred__titulo">Productos</p><ul class="fx-pred__lista">';
          productos.forEach(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            html += '<li><a class="fx-pred__item" href="' + esc(p.url) + '">' +
              (img ? '<img class="fx-pred__img" src="' + esc(conAncho(img, 120)) + '" alt="" width="52" height="52" loading="lazy">' : '<span class="fx-pred__img"></span>') +
              '<span class="fx-pred__nombre">' + esc(p.title) + '</span>' +
              (p.available === false ? '<span class="fx-pred__agotado">Agotado</span>' : '<span class="fx-pred__precio">' + pesos(p.price) + '</span>') +
              '</a></li>';
          });
          html += '</ul>';
        }
        if (colecciones.length) {
          html += '<p class="fx-pred__titulo">Colecciones</p><ul class="fx-pred__chips">';
          colecciones.forEach(function (c) {
            html += '<li><a class="fx-pred__chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
          });
          html += '</ul>';
        }
        html += '<a class="fx-pred__todos" href="' + RAIZ + 'search?q=' + encodeURIComponent(q) + '">Ver todos los resultados para «' + esc(q) + '» →</a>';
      }
      caja.innerHTML = html;
      caja.hidden = false;
      if (nota) nota.hidden = true;
    }

    function buscar() {
      var q = input.value.trim();
      if (q.length < 2) { limpiar(); return; }
      if (control) control.abort();
      control = 'AbortController' in window ? new AbortController() : null;
      var url = RAIZ + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url, control ? { signal: control.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          if (input.value.trim() !== q) return;
          pintar(q, (d.resources && d.resources.results) || {});
        })
        .catch(function (e) { if (e.name !== 'AbortError') limpiar(); });
    }

    input.addEventListener('input', function () {
      clearTimeout(espera);
      espera = setTimeout(buscar, 180);
    });

    function enlaces() { return Array.prototype.slice.call(caja.querySelectorAll('a')); }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && !caja.hidden) {
        var a = enlaces();
        if (a.length) { e.preventDefault(); a[0].focus(); }
      }
    });

    caja.addEventListener('keydown', function (e) {
      var a = enlaces();
      var i = a.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < a.length - 1) { e.preventDefault(); a[i + 1].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? a[i - 1] : input).focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); input.focus(); }
    });
  }

  /* ---------- Barra de compra fija (producto, celular) ---------- */
  function iniciarCompraFija() {
    var barra = document.querySelector('[data-fx-compra-fija]');
    var principal = document.querySelector('product-form button[name="add"]');
    if (!barra || !principal || !('IntersectionObserver' in window)) return;
    var boton = barra.querySelector('[data-fx-compra-btn]');
    var precio = barra.querySelector('[data-fx-compra-precio]');
    var seccion = principal.closest('[id^="shopify-section"]') || document;
    var celular = window.matchMedia('(max-width: 749px)');
    barra.hidden = false;

    function copiarEstado() {
      var agotado = principal.disabled;
      boton.disabled = agotado;
      boton.textContent = agotado ? 'Agotado' : 'Agregar al carrito';
      var p = seccion.querySelector('.price--on-sale .price-item--sale') || seccion.querySelector('.price-item--regular');
      if (p && p.textContent.trim()) precio.textContent = p.textContent.trim();
    }

    function mostrar(visible) {
      barra.classList.toggle('is-visible', visible);
      document.body.classList.toggle('fx-con-compra-fija', visible && celular.matches);
    }

    new IntersectionObserver(function (entradas) {
      mostrar(!entradas[0].isIntersecting);
    }).observe(principal);

    new MutationObserver(copiarEstado).observe(principal, {
      attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true
    });

    boton.addEventListener('click', function () {
      if (principal.disabled) return;
      principal.click();
    });

    copiarEstado();
  }

  /* ---------- WhatsApp ---------- */
  function iniciarWhatsApp() {
    var wa = document.querySelector('.fx-wa');
    if (!wa) return;
    // Con ratón o dedo (detail > 0) se suelta el foco para que el anillo no se quede
    // al volver de WhatsApp. Con teclado (detail = 0) el foco se conserva.
    wa.addEventListener('click', function (e) {
      if (e.detail > 0) wa.blur();
    });
  }

  /* ---------- Carrito al día ----------
     Dawn borra y cambia cantidades por número de renglón (line). Si el cajón se
     quedó viejo (botón Atrás, otra pestaña), el renglón 2 de la pantalla ya no es
     el 2 del carrito real y se borraba otro producto. Aquí: (1) antes de cada
     cambio se comprueba contra /cart.js que el renglón sea el mismo producto, y si
     no, se re-pinta el cajón y el cambio se aplica al renglón correcto; (2) el
     cajón se re-pinta al abrirlo desde el icono, al volver con Atrás y al volver a
     la pestaña, solo si cambió. */
  function rutaCarrito() {
    return (window.routes && window.routes.cart_url) || RAIZ + 'cart';
  }

  function varianteDeFila(fila) {
    var a = fila && fila.querySelector('.cart-item__name');
    var m = a && /[?&]variant=(\d+)/.exec(a.getAttribute('href') || '');
    return m ? m[1] : null;
  }

  // Lo que se ve: producto y cantidad de cada renglón, tal como los pintó Liquid.
  function firma(raiz) {
    if (!raiz) return '';
    return Array.prototype.map.call(raiz.querySelectorAll('.cart-item'), function (fila) {
      var q = fila.querySelector('.quantity__input');
      return varianteDeFila(fila) + 'x' + (q ? q.getAttribute('value') : '');
    }).join(',');
  }

  function refrescarCajon(forzar) {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return Promise.resolve(false);
    return fetch(rutaCarrito() + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (s) {
        var doc = new DOMParser().parseFromString(s['cart-drawer'] || '', 'text/html');
        var nuevo = doc.querySelector('.drawer__inner');
        var actual = cajon.querySelector('.drawer__inner');
        if (!nuevo || !actual) return false;
        if (!forzar && firma(nuevo) === firma(actual)) return false;
        actual.innerHTML = nuevo.innerHTML;
        var cd = doc.querySelector('cart-drawer');
        cajon.classList.toggle('is-empty', cd ? cd.classList.contains('is-empty') : !nuevo.querySelector('.cart-item'));
        var burbuja = document.getElementById('cart-icon-bubble');
        var b = s['cart-icon-bubble'] && new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (burbuja && b) burbuja.innerHTML = b.innerHTML;
        // Si el cajón está abierto, el foco vuelve adentro (el re-pintado lo suelta).
        if (cajon.classList.contains('active') && typeof trapFocus === 'function') {
          var zona = cajon.classList.contains('is-empty') ? cajon.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
          var foco = cajon.querySelector('.drawer__inner') || cajon.querySelector('.drawer__close');
          if (zona && foco) trapFocus(zona, foco);
        }
        return true;
      })
      .catch(function () { return false; });
  }

  // /cart no tiene cajón: si lo que se ve no es el carrito real, se recarga la página.
  function revisarPaginaCarrito() {
    var lista = document.getElementById('main-cart-items');
    if (!lista || !lista.dataset.id) return;
    fetch(rutaCarrito() + '?sections=' + encodeURIComponent(lista.dataset.id), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (s) {
        var doc = new DOMParser().parseFromString(s[lista.dataset.id] || '', 'text/html');
        if (firma(doc) !== firma(document.querySelector('cart-items'))) window.location.reload();
      })
      .catch(function () {});
  }

  function ponerAlDia() {
    if (document.querySelector('cart-drawer')) refrescarCajon(false);
    else if (document.querySelector('cart-items')) revisarPaginaCarrito();
  }

  function protegerCambios() {
    if (!window.customElements || !window.fetch) return;
    customElements.whenDefined('cart-items').then(function () {
      var Clase = customElements.get('cart-items');
      var original = Clase && Clase.prototype.updateQuantity;
      if (!original || original.__fx) return;
      var envuelta = function (line, quantity, name, variantId) {
        var lista = this;
        var args = arguments;
        var fila = lista.querySelector('#CartDrawer-Item-' + line) || lista.querySelector('#CartItem-' + line);
        var vid = varianteDeFila(fila);
        if (!vid) return original.apply(lista, args);
        // Bloquea la lista ya, como hace Dawn, para que un doble clic no mande dos cambios.
        if (typeof lista.enableLoading === 'function') lista.enableLoading(line);
        fetch(rutaCarrito() + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (carrito) {
            var real = carrito.items[parseInt(line, 10) - 1];
            if (real && String(real.variant_id) === vid) return original.apply(lista, args);
            var i = -1;
            carrito.items.forEach(function (it, n) { if (i < 0 && String(it.variant_id) === vid) i = n; });
            // /cart: el cambio se aplica por la llave del renglón (no por número) y se recarga.
            if (lista.tagName !== 'CART-DRAWER-ITEMS') {
              var cambio = i < 0 ? Promise.resolve() : fetch((window.routes && window.routes.cart_change_url) || RAIZ + 'cart/change', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: carrito.items[i].key, quantity: parseInt(quantity, 10) })
              });
              cambio.catch(function () {}).then(function () { window.location.reload(); });
              return;
            }
            return refrescarCajon(true).then(function (ok) {
              if (!ok) { window.location.reload(); return; }
              var nueva = document.querySelector('cart-drawer-items');
              // Si el producto ya no estaba en el carrito, basta con mostrar el carrito real.
              if (i < 0 || !nueva) return;
              var input = nueva.querySelector('#Drawer-quantity-' + (i + 1));
              if (input) input.value = quantity;
              original.call(nueva, i + 1, quantity, name, variantId);
            });
          })
          .catch(function () { original.apply(lista, args); });
      };
      envuelta.__fx = true;
      Clase.prototype.updateQuantity = envuelta;
    });
  }

  function iniciarCarrito() {
    protegerCambios();
    // Al abrir el cajón desde el icono (Dawn lo abre en el acto; esto lo corrige si estaba viejo).
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#cart-icon-bubble')) refrescarCajon(false);
    }, true);
    // Atrás/Adelante: desde la caché del navegador (persisted) o con el HTML guardado.
    window.addEventListener('pageshow', function (e) { if (e.persisted) ponerAlDia(); });
    var nav = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') ponerAlDia();
    // Otra pestaña pudo cambiar el carrito.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') ponerAlDia();
    });
  }

  function iniciar() {
    iniciarBusqueda();
    iniciarCompraFija();
    iniciarWhatsApp();
    iniciarCarrito();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
